/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `A_FAZER` - A Fazer * `EM_ANDAMENTO` - Em Andamento * `CONCLUIDO` - Concluído
 */
export enum Situacao8b4Enum {

    A_FAZER = 'A_FAZER',

    EM_ANDAMENTO = 'EM_ANDAMENTO',

    CONCLUIDO = 'CONCLUIDO'
}

